<div class="app-faculties-selection-list-restriction-form">
  <app-study-form-input
    [control]="restriction.controls.unit"
    [groupedOptions]="restrictionUnitOptions"
    (undo)="resetRestriction.emit({ field: 'unit' })"
    label="Tipo de restricción"
    type="groupedSelect"
  ></app-study-form-input>
  <app-study-form-input
    class="value"
    label="Valor"
    type="text"
    [control]="restriction.controls.value"
    (undo)="resetRestriction.emit({ field: 'value' })"
  ></app-study-form-input>
</div>
